<div class="custom-dialog">
  <!-- Email Step -->
  <div *ngIf="step === 'email'" class="dialog-content">
    <div class="dialog-header">
      <h2 class="dialog-title">Change Email</h2>
      <div class="close-btn" style="border: none; cursor: pointer;" (click)="close()">
        <i class="fa-solid fa-xmark"></i>
      </div>
    </div>

    <div class="form-group">
      <label class="form-label">Email</label>
      <input
        class="custom-input"
        placeholder="Enter Mail ID"
        formControlName="email"
        [formControl]="form.controls['email']"
        type="email"
      />
      <div class="error-message" *ngIf="form.controls['email'].hasError('email')">
        Invalid email
      </div>
    </div>

    <div class="dialog-actions d-flex justify-content-start" >
      <button class="custom-button primary" style="background-color: #0C085C; padding:10px ;" (click)="sendOtp()">Next</button>
    </div>
    <div class="error-message" *ngIf="emailError">
      {{ emailError }}
    </div>
  </div>

  <!-- OTP Step -->
  <div *ngIf="step === 'otp'" class="dialog-content">
    <h2 class="dialog-title">Verification Code</h2>

    <p class="verification-text">
      Please type the verification code sent to<br>
      <strong>{{ sentEmail }}</strong>
    </p>

    <div class="otp-container">
      <input
        class="otp-input"
        maxlength="1"
        (input)="onOtpInput($event, 0)"
        (keydown)="onOtpKeydown($event, 0)"
        #otp0
      />
      <input
        class="otp-input"
        maxlength="1"
        (input)="onOtpInput($event, 1)"
        (keydown)="onOtpKeydown($event, 1)"
        #otp1
      />
      <input
        class="otp-input"
        maxlength="1"
        (input)="onOtpInput($event, 2)"
        (keydown)="onOtpKeydown($event, 2)"
        #otp2
      />
      <input
        class="otp-input"
        maxlength="1"
        (input)="onOtpInput($event, 3)"
        (keydown)="onOtpKeydown($event, 3)"
        #otp3
      />
    </div>

    <div class="resend-section">
      I didn't receive a code!
      <a
        class="resend-link"
        (click)="resendOtp()"
        [class.disabled]="resendDisabled"
        [style.pointer-events]="resendDisabled ? 'none' : 'auto'"
      >
        resend code
        <span *ngIf="resendDisabled">({{ resendCountdown }}s)</span>
      </a>
    </div>

    <div class="resend-message" *ngIf="resendMessage">
      {{ resendMessage }}
    </div>


    <div class="dialog-actions d-flex justify-content-start">
      <button class="custom-button primary" style="background-color: #0C085C; padding:10px ;" (click)="verifyOtp()">Verify</button>
    </div>
    <div class="error-message" *ngIf="otpError">
      {{ otpError }}
    </div>

  </div>
</div>